import { useEffect, useState } from 'react'

import {
    STORY_MAP_BOARD_TAB_BAR_HOST_ATTR,
    STORY_MAP_BOARD_TAB_BAR_SLOT_ATTR,
    attachTabBarSlot,
    removeTabBarHost,
} from '../../projectTabBarPortal'
import styles from '../../ProjectStoryMapBoard.module.css'

const useBoardTabBarPortal = () => {
    const [tabBarSlot, setTabBarSlot] = useState(null)
    const [useInlineHeader, setUseInlineHeader] = useState(false)

    useEffect(() => {
        let timer = null
        let retryTimer = null

        const attach = () => {
            const slot = attachTabBarSlot({
                hostAttr: STORY_MAP_BOARD_TAB_BAR_HOST_ATTR,
                slotAttr: STORY_MAP_BOARD_TAB_BAR_SLOT_ATTR,
                hostClassName: styles.boardTabBarHost,
            })

            if (!slot) return false

            setTabBarSlot(slot)
            setUseInlineHeader(false)
            return true
        }

        if (!attach()) {
            timer = window.setTimeout(attach, 0)
            retryTimer = window.setTimeout(() => {
                if (!attach()) {
                    setUseInlineHeader(true)
                }
            }, 120)
        }

        return () => {
            if (timer) window.clearTimeout(timer)
            if (retryTimer) window.clearTimeout(retryTimer)
            removeTabBarHost(STORY_MAP_BOARD_TAB_BAR_HOST_ATTR)
            setTabBarSlot(null)
            setUseInlineHeader(false)
        }
    }, [])

    return { tabBarSlot, useInlineHeader }
}

export default useBoardTabBarPortal
